/**
 * Association types for Portfolio Studio.
 * Synced from content/draft.json — edit via /admin (Assoc. types tab or + New association type).
 */
export const associationTypes = [
  {
    id: "pillars",
    label: "Research Pillars",
    kind: "collection",
    collection: "researchPillars",
    optionId: "id",
    optionLabel: "shortLabel"
  },
  {
    id: "publications",
    label: "Publications",
    kind: "collection",
    collection: "publications",
    optionId: "title",
    optionLabel: "title"
  },
  {
    id: "links",
    label: "External Links",
    kind: "urls"
  },
  {
    id: "notes",
    label: "Notes",
    kind: "text"
  },
  {
    id: "news",
    label: "News",
    kind: "collection",
    collection: "newsItems",
    optionId: "title",
    optionLabel: "title"
  },
  {
    id: "features",
    label: "Features",
    kind: "collection",
    collection: "features",
    optionId: "title",
    optionLabel: "title"
  }
];

export const DEFAULT_ASSOCIATION_TYPES = associationTypes;

export const COLLECTION_CHOICES = [
  { id: "phdResearchProjects", label: "Projects" },
  { id: "researchPillars", label: "Pillars" },
  { id: "collaborators", label: "Collaborators" },
  { id: "mentoring", label: "Mentoring" },
  { id: "publications", label: "Publications" },
  { id: "newsItems", label: "News" },
  { id: "features", label: "Features" },
];
